import React from "react";
import profileImage from "../../assets/images/team/dvirCohen";
import {
  FaLinkedin,
  FaXTwitter,
  FaGithub,
  FaYoutube,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa6";
import styles from "./ProfessionalCardTopPart.module.css";
import { Avatar } from "@mui/material";

const ProfessionalCardTopPart = (props) => {
  // console.log("--- props: ", props);

  const brokerLicenses = props.licenses == null ? [] : props.licenses.filter((l) => l.license_type === "broker" && l.is_verified);
  const realtorLicenses = props.licenses == null ? [] : props.licenses.filter((l) => l.license_type === "realtor"  && l.is_verified);

  const labelElement = () => {
    let label = "";
    if (brokerLicenses.length > 0 && realtorLicenses.length > 0) {
      label = "Broker and Realtor";
    } else if (brokerLicenses.length) {
      label = "Broker";
    } else if (realtorLicenses.length) {
      label = "Realtor";
    } else {
      label = null;
    }

    if (label) {
      return <h3 className={styles.label}>{label}</h3>;
    } else {
      return <h3 className={styles.noLabel}>Not a verified agent!</h3>;
    }

    return null;
  };

  const handleMessagePro = (event) => {
    event.preventDefault();

    // alert("message");
  };

  return (
    <div className={styles.personal}>
      <span className={styles.pro}>PRO</span>
      {props.image ? (
        <img
          src={props.image ? props.image : profileImage}
          alt=""
          className={styles.profileImage}
        />
      ) : (
        <Avatar className={styles.profileImageImp} alt={props.name} src="" />
      )}
      <h2 className={styles.name}>{props.name}</h2>
      {labelElement()}
      <p className={styles.state}>{props.state}</p>
      <p className={styles.stack}>{props.position}</p>
      <div className={styles.buttons}>
        <button
          type="button"
          className={styles.primaryButton}
          onClick={handleMessagePro}
        >
          Message
        </button>
        {/* <button className={styles.secondaryButton}>Following</button> */}
      </div>
      <div className={styles.social}>
        {props.linkedinLink && (
          <FaLinkedin
            onClick={() => {
              window.open(props.linkedinLink, "_blank");
            }}
            className={styles.socialIcon}
          />
        )}

        {/* {props.linkedinLink && (
          <FaXTwitter
            onClick={() => {
              window.open(props.linkedinLink, "_blank");
            }}
            className={styles.socialIcon}
          />
        )} */}
        {props.tiktokLink && (
          <FaTiktok
            onClick={() => {
              window.open(props.tiktokLink, "_blank");
            }}
            className={styles.socialIcon}
          />
        )}
        {props.youtubeLink && (
          <FaYoutube
            onClick={() => {
              window.open(props.youtubeLink, "_blank");
            }}
            className={styles.socialIcon}
          />
        )}
        {props.instagramLink && (
          <FaInstagram
            onClick={() => {
              window.open(props.instagramLink, "_blank");
            }}
            className={styles.socialIcon}
          />
        )}
      </div>
    </div>
  );
};

export default ProfessionalCardTopPart;
